import { useTranslation } from 'react-i18next';
import { Button, Form, Radio } from 'antd';
import { useState } from 'react';
import { customizeRequiredMark } from '../../../helpers/formHelper';
import { useNavigate } from 'react-router-dom';
import { useNotificationContext } from '../../../contexts/NotificationContext';
import { getServerErrorMsg } from '../../../helpers/errorHandler';
import { trimValues } from '../../../helpers/utilityHelper';
import RegisterLayout from '../../../layouts/RegisterLayout';
import { CitizenRegisterForm } from '../components/CitizenRegisterForm';
import { useRegisterUser } from '../../../api/hooks/useUserQuery';
import { UserTypes } from '../../../enums/UserTypeEnum';

const CitizenRegistration = () => {
  const { t } = useTranslation(['register', 'common', 'form']);

  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { successNotification, errorNotification } = useNotificationContext();
  const registerCitizen = useRegisterUser();

  const onFinish = (data: any) => {
    let values = trimValues(data);
    values = {
      ...values,
      userType: UserTypes.CITIZEN,
    };

    registerCitizen.mutate(values, {
      onSuccess: () => {
        successNotification(t('citizenRegistered'));
        navigate('/signIn', { replace: true });
        clearForm();
      },
      onError: (response: any) => {
        let errorMsg = getServerErrorMsg(response);
        errorNotification(errorMsg);
      },
    });
  };

  const clearForm = () => {
    form.resetFields();
  };

  return (
    <>
      <div className="flex justify-center">
        <div className="w-full">
          <Form
            form={form}
            onFinish={onFinish}
            layout="vertical"
            requiredMark={customizeRequiredMark}
          >
            <CitizenRegisterForm />

            <Form.Item className="mt-4 text-center md:text-right">
              <Button onClick={() => navigate('/signin')} style={{ marginRight: 8 }}>
                {t('back')}
              </Button>
              <Button type="primary" htmlType="submit" loading={registerCitizen.isPending}>
                {t('register')}
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>
    </>
  );
};

const CitizenRegistrationPage = () => {
  const { t } = useTranslation('register');
  return (
    <RegisterLayout
      content={<CitizenRegistration />}
      pageTitle={t('citizenRegistrationPage')}
    ></RegisterLayout>
  );
};

export default CitizenRegistrationPage;
